<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import ApiDocs from '@kidzonet/vue3-redoc'

const { t } = useI18n()

const schemes = computed(() => [{
    title: t('web_common.api.scheme.billing'),
    to: 'billing',
}, {
    title: t('web_common.api.scheme.dbExplorer'),
    to: 'dbExplorer',
}])
</script>

<template>
    <ApiDocs
        back="/apps"
        :menu="schemes"
        :one-line="false"
    />
</template>
